<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.99653 4.94354V6.06854M3.23901 6.10004C3.23901 6.51425 3.59654 6.80508 4.01076 6.80508C4.42497 6.80508 4.7825 6.51425 4.7825 6.10004M4.24666 4.81836C4.24666 4.95643 4.13473 5.06836 3.99666 5.06836C3.85858 5.06836 3.74666 4.95643 3.74666 4.81836C3.74666 4.68029 3.85858 4.56836 3.99666 4.56836C4.13473 4.56836 4.24666 4.68029 4.24666 4.81836Z"
      stroke="currentColor"
      stroke-width="0.4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.10122 5.90013C3.10122 6.01059 3.19076 6.1 3.30122 6.1H4.70012C4.81057 6.1 4.90012 6.01053 4.90012 5.90007C4.90012 5.78311 4.90012 5.61716 4.90012 5.40845C4.90012 4.96703 4.90012 4.58555 5.32517 4.08555C5.78091 3.58116 5.87559 3.45909 5.87559 2.70909C5.83133 1.86753 5.20981 1 3.99676 1C2.7837 1 2.11792 1.9576 2.11792 2.70909C2.11792 3.5633 2.45621 3.76266 2.66667 4.08555C2.87713 4.40845 3.10122 4.85529 3.10122 5.40845C3.10122 5.63625 3.10122 5.79371 3.10122 5.90013Z"
      stroke="currentColor"
      stroke-width="0.4"
    />
  </svg>
</template>
